/**
 * UsedInPopover Component
 *
 * Displays a count of playbooks using a criteria/confluence item.
 * Click/tap opens a popover showing the list of playbook names.
 * Works on both desktop and mobile.
 */

import React from 'react';

import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  Button,
} from '@enfomentis/ui';

export interface UsedInPopoverProps {
  /** Array of playbook names that use this item */
  playbookNames: string[];
}

export const UsedInPopover: React.FC<UsedInPopoverProps> = ({ playbookNames }) => {
  const count = playbookNames.length;

  // Empty state - no playbooks use this item
  if (count === 0) {
    return (
      <span className="text-sm text-text-tertiary">
        0 playbooks
      </span>
    );
  }

  return (
    <Popover isNonModal placement="bottom">
      <PopoverTrigger>
        <Button
          variant="light"
          size="sm"
          className="text-sm text-text-secondary hover:text-text-primary min-w-0 px-1"
        >
          {count} {count === 1 ? 'playbook' : 'playbooks'}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="p-3">
        <div className="w-72 space-y-1">
          <p className="text-xs font-medium text-text-secondary mb-2">
            Used in:
          </p>
          <ul className="space-y-1 max-h-48 overflow-y-auto min-w-0">
            {playbookNames.map((name, index) => (
              <li
                key={index}
                className="text-sm text-text-primary truncate w-full"
                title={name}
              >
                {name}
              </li>
            ))}
          </ul>
        </div>
      </PopoverContent>
    </Popover>
  );
};
